// extracted by mini-css-extract-plugin
export default {"FullWidth":"full-width_FullWidth__1m1DP","Article":"full-width_Article__-wv3z","image":"full-width_image__1em9o"};